import Permissions from '@/app/permissions/Permissions';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';

const ORGANIZATION_DETAILS_TABS = {
    DETAILS:
    {
        name: 'details',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ORGANIZATION_READ.name] })
    },
    USERS:
    {
        name: 'users',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.USER_LIST.name] })
    },
    DIRECT_ORGANIZATIONS:
    {
        name: 'direct_organizations',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.ORGANIZATION_LIST.name] })
    },
    SUBSCRIPTIONS:
    {
        name: 'subscriptions',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SUBSCRIPTION_LIST.name] })
    },
    REMOTE_COLLECTIONS:
    {
        name: 'remote_collections',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.PAYMENT_LIST_REMOTE_COLLECTIONS.name] })
    },
    PARENT_PLANS:
    {
        name: 'parent_plans',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SUBSCRIPTION_PLAN_LIST_PROVIDER_PLANS.name] })
    },
    SIM_CARDS:
    {
        name: 'sim_cards',
        hasPermissions: (permissions) => hasRequiredPermissions({ permissions, requiredPermissions: [Permissions.SIM_LIST.name] })
    }
};

ORGANIZATION_DETAILS_TABS.DEFAULT = ORGANIZATION_DETAILS_TABS.DETAILS;

export default ORGANIZATION_DETAILS_TABS;